import { Paper, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Vector } from "p5";
import React, { memo, useContext, useEffect, useState } from "react";
import { isMobile, withOrientationChange } from "react-device-detect";
import { createPortal } from "react-dom";
import { ReactP5Wrapper as P5Wrapper } from "react-p5-wrapper";
import api from "../apiUtilities";
import { Context } from "../Context/context";
import { useCurrentDimensions } from "../History/ResponsiveUtilities";
import sketch from "./baseSketch";
import Shape from "./SketchUtilities/Shape";
import uiSketch from "./uiSketch";
import {useSizingContext} from '../Context/SizingContext'
interface ThemeProps {
  topOffset: string | number;
}

const useStyles = makeStyles<Theme, ThemeProps>((theme) => ({
  background: {
    backgroundColor: "white",
  },
  canvasContainer: {
    elevation: 4,
  },
  canvasWrapper: (props) => ({
    margin: "auto",
    position: "fixed",
    top: "0px",
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "0px",
    height: "0px",
  }),
}));

let color: string = "";

const Canvas = (props: any) => {
  const { state:{ isSmallScreen, isPortrait } } = useSizingContext();
  const [locations, setLocations] = useState<Vector[]>([]);
  const { state, dispatch } = useContext(Context);
  const offset = `${window.innerHeight - (window.innerHeight - 50)}px`;
  const styles = useStyles({ topOffset: isMobile ? offset : 0 });
  const [displayplaceHolder, dismissPlaceHolder] = useState<boolean>(true);

  const getShouldRotate = ()=> {
    const res =  ( isMobile && isPortrait && isSmallScreen );
    return res;
  }
  const [shouldRotate, setShouldRotate] = useState<boolean>(getShouldRotate());


  const dimensions = useCurrentDimensions(
    state.CanvasSizeData.aspectRatio,
    state.CanvasSizeData.name === "Square",
    isPortrait
  );

  useEffect(() => {
    api.initializeSession(dispatch);

    return () => {
      dispatch({ type: "clear_sessions", value: undefined });
    };
  }, []);

  if (
    dimensions.width !== state.dimensions.width ||
    dimensions.height !== state.dimensions.height
  ) {
    dispatch({
      type: "set_dimensions",
      value: dimensions,
    });
  }

  const globalPositioning = (locations: Vector[]) => {
    setLocations(locations);
  };

  const setGlobalColor = (c: string) => {
    color = c;
  };

  const setHistoryLength = (index: number) => {
    dispatch({ type: "set_history_length", value: index });
  };

  const handleColorSelect = (color: string) => {
    setGlobalColor(color);
    dispatch({ type: "set_brush_color", value: [color] });
    dispatch({ type: "set_colorselect_mode", value: false });
  };

  const shape = new Shape(state.brushColor[0]);

  const setColorPreview = () => {
    // const colorPicker_EL = document.getElementById(
    //   isMobile ? "colorPickerMobile" : "colorPicker"
    // );
    const colorPicker_EL = document.getElementById( "colorPickerMobile" );
    if (colorPicker_EL) {
      return createPortal(
        <div style={{ display: "block", width: "100%", pointerEvents: "none" }}>
          <div
            style={{
              background: `${color}`,
              width: "100%",
              color: "white",
              height: "40px",
              fontSize: "2rem",
              lineHeight: "40px",
              verticalAlign: "middle",
              textAlign: "center",
              display: "block",
              opacity: state.globalColorData.alpha,
            }}
          >
            MY COLORS
          </div>
        </div>,
        colorPicker_EL
      );
    }
  };

  return (
    <>
      <Paper className={styles.canvasContainer}>
        {setColorPreview()}

        <div
          className={styles.canvasWrapper}
          style={{
            zIndex: 4,
            cursor:
              state.isColorSelect || state.isColorfillMode ? "none" : "auto",
          }}
        >
          <div>
            <div
              className={styles.canvasWrapper}
              id={"placeholder"}
              style={{
                width:
                  isMobile && isPortrait
                    ? `${state.dimensions.height}px`
                    : `${state.dimensions.width}px`,
                height:
                  isMobile && isPortrait
                    ? `${state.dimensions.width}px`
                    : `${state.dimensions.height}px`,
                zIndex: 1000000,
                position: "fixed",
                display: displayplaceHolder ? "block" : "none",
              }}
              onTouchStart={() => {
                dismissPlaceHolder(false);
              }}
              onMouseDown={() => {
                dismissPlaceHolder(false);
              }}
              onClick={() => {
                dismissPlaceHolder(false);
              }}
            >
              <img
                src={require("../../Assets/logo.svg")}
                style={{ position: "absolute", bottom: "0%" }}
              />
              <p
                style={{
                  position: "absolute",
                  bottom: "25%",
                  textAlign: "center",
                  width: "100%",
                  fontFamily: "'amatic', cursive",
                  fontSize: "3vw",
                }}
              >
                This is your canvas! Click anywhere to paint!
              </p>
            </div>
          </div>

          <div className={styles.canvasWrapper} style={{ zIndex: 2 }}>
            <div
              className={isMobile && isPortrait && isSmallScreen ? "portrait" : "landscape"}
              id={"threeCanvas"}
            ></div>
          </div>
          <div
            className={isMobile && isPortrait && isSmallScreen ? "portrait" : "landscape"}
            style={{ zIndex: 6 }}
            id={"uiSketchContainer"}
          >
            <P5Wrapper
              dimensions={state.dimensions}
              image={
                state.shapeSettings.imageIndex
                  ? state.shapeSettings.imageIndex
                  : -1
              }
              images={state.images}
              isColorfillMode={state.isColorfillMode}
              isColorSelectMode={state.isColorSelect}
              isPortrait={isPortrait}
              sketch={uiSketch}
              isMobile={isMobile}
              shapeInst={shape}
              shapeType={state.shapeSettings.shape}
              shapeMode={state.shapeSettings.shapeRotation}
              shape
              brushMode={state.brushType}
              brushSize={state.shapeSettings.shapeSize}
              locationsArr={[...locations]}
            />
          </div>
        </div>
        <div
          className={`${styles.canvasWrapper} ${
            isMobile && isPortrait && isSmallScreen ? "portrait" : "landscape"
          }`}
          style={{ zIndex: 3 }}
          id={"sketchContainer"}
        >
          <P5Wrapper
            {...state}
            sketch={sketch}
            drawnOnMobile={isMobile}
            isPortrait={isPortrait}
            shape={shape}
            canvasSize={{
              "width": dimensions.width,
              "height": dimensions.height
            }}
            setGlobalColor={setGlobalColor}
            setLocations={globalPositioning}
            setHistoryPos={setHistoryLength}
            setColorFromSelect={handleColorSelect}
            stopClickEvents={
              state.currentActiveMenu === "brush" ||
              state.currentActiveMenu === "color" ||
              state.currentActiveMenu === "new"
            }
          />
        </div>
      </Paper>
    </>
  );
};

export default memo(withOrientationChange(Canvas));
